import { Button, Stack, Text } from '@mantine/core';
import { IconPalette } from '@tabler/icons-react';
import { useState } from 'react';
import { Navigate } from 'react-router';
import PageLoader from 'src/UI/loader/PageLoader';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import useCurrentUser from 'src/admin/users/hooks/useCurrentUser';
import { useSessionData } from 'src/auth/SessionDataHook';
import { useIsAfternoon } from 'src/common/useIsAfternoonHook';
import BrandAssetBuilderDrawer from 'src/secret-menu/brand-asset-builder/BrandAssetBuilderDrawer';

export default function BrandAssetBuilderTab() {
  const { isAfternoon } = useIsAfternoon();
  const { session } = useSessionData();
  const { currentUser } = useCurrentUser();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const authLoading = !session || !currentUser;

  if (authLoading) {
    return <PageLoader />;
  }

  if (!isAfternoon) {
    return <Navigate to="/secret-menu/companies" replace />;
  }

  return (
    <Stack gap="lg" maw={640} p="md" bg="white">
      <Stack gap={4}>
        <Text size="displayXs" fw={FONT_WEIGHTS.semibold}>
          Brand asset builder
        </Text>
        <Text size="textMd" c="gray.6">
          Generate a tenant&apos;s branding pack from a logo: extract a colour palette, pick a title
          page theme, and produce the export-assets document set.
        </Text>
      </Stack>
      <Button
        leftSection={<IconPalette size={16} />}
        onClick={() => setDrawerOpen(true)}
        w="fit-content"
      >
        Start building brand assets
      </Button>
      <BrandAssetBuilderDrawer opened={drawerOpen} close={() => setDrawerOpen(false)} />
    </Stack>
  );
}
